import React from 'react';
import styled from '@emotion/styled';
import MuiContainer from '@mui/material/Container';
import { spacing, type ContainerProps as MuiContainerProps } from '@mui/system';

import { GRID } from '@/constants';

const StyledMuiContainer = styled(MuiContainer)`
  ${spacing}
`;

type ContainerProps = {
  className?: string;
} & MuiContainerProps &
  Record<string, unknown>;

const Container = ({ className, maxWidth, children, ...props }: ContainerProps) => {
  const containerMaxWidth = maxWidth || GRID.CONTAINER_MAX_WIDTH;

  return (
    <StyledMuiContainer className={className} maxWidth={containerMaxWidth} {...props}>
      {children}
    </StyledMuiContainer>
  );
};

export default Container;
